import { render, staticRenderFns } from "./SettingsCacheView.vue?vue&type=template&id=2acfdd20&"
import script from "./SettingsCacheView.vue?vue&type=script&lang=js&"
export * from "./SettingsCacheView.vue?vue&type=script&lang=js&"
import style0 from "./SettingsCacheView.vue?vue&type=style&index=0&id=2acfdd20&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports